<template>
	<div v-if="$route.name!='marketing'" class="marketing">
		<div class="header">
			<el-menu router :default-active="$route.name" mode="horizontal">
				<el-menu-item index="marketing_coupon" :route="{name:'marketing_coupon'}">优惠券</el-menu-item>
				<el-menu-item index="marketing_store" :route="{name:'marketing_store'}">合作门店</el-menu-item>
				<el-menu-item index="marketing_card" :route="{name:'marketing_card'}">优惠名片</el-menu-item>
			</el-menu>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		created() {
			this.resetRoute();
		},
		methods: {
			resetRoute(){
				const that = this;
				if (that.$route.name == 'marketing') {
					that.$router.push({
						name: 'marketing_coupon'
					});
				}
			}
		},
		watch: {
			$route: {
				handler: 'resetRoute'
			}
		}
	}
</script>
